import { render, staticRenderFns } from "./ProveedorComponent.vue?vue&type=template&id=4e3a925c&"
import script from "./ProveedorComponent.vue?vue&type=script&lang=js&"
export * from "./ProveedorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports